import React, { useState, useContext, useEffect } from "react";
import { usersPathTo, providersPathTo, adminsPathTo } from "../utils/Api";
import { Button, Box, Typography, FormControl, InputLabel, MenuItem, Select, Divider, TextField } from '@mui/material';
import SnackbarContext from "../contexts/SnackbarContext";
import FormBox from '../components/building_blocks/FormBox';
import axios from 'axios';


const NewProvider = () => {
  const [usersList, setUsersList] = useState([]);
  const [user, setUser] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [selectedUser, setSelectedUser] = useState('');
  const [userSuccess, setUserSuccess] = useState(false);
  const [cep, setCep] = useState('');
  const [address, setAddress] = useState({
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    localidade: '',
    uf: '',
  });

  const [provider, setProvider] = useState({
    name: '',
    cnpj: '',
    phone: '',
    description: '',
    address: {
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      localidade: '',
      uf: ''
    }
  });

  useEffect(() => {
    adminsPathTo.users_list().then((result) => {
      setUsersList(result.data);
    })
  }, []);

  const { openSnackbar } = useContext(SnackbarContext);

  const handleUserInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const handleProviderInputChange = (event) => {
    const { name, value } = event.target;
    setProvider({ ...provider, [name]: value });
  };

  const handleSubmitUser = (event) => {
    event.preventDefault();
    usersPathTo.signup(user).then(result => {
      openSnackbar("Usuário cadastrado com sucesso. Enviamos um e-mail para confirmação da conta", "success");
      setUserSuccess(true);
      setProvider({account_id: result.data.account_id})
    }, error => {})
  };

  const confirmSelectedUser = (event) => {
    event.preventDefault();
    setUserSuccess(true);
    setProvider({account_id: selectedUser.account_id})
  }

  const handleBuscaApiCall = async (event) => {
    const { name, value, type } = event.target;
    const cepLimpo = value.replace(/\D/g, '');
    setCep(cepLimpo);
    if (cepLimpo.length == 8) { 
      try {
        const response = await axios.get('https://viacep.com.br/ws/' + cepLimpo + '/json/');
        const addressData = response.data;
        setAddress({
          ...address, 
          ...addressData
        })
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleAddressChange = (event) => {
    event.preventDefault();
    const { name, value, type } = event.target;
    setAddress({...address, [name]: value});
  }

  const handleSubmitProvider = (event) => {
    event.preventDefault();
    provider.address_attributes = address;
    providersPathTo.save(provider).then(result => {
      setProvider({
        account_id: '',
        cnpj: '',
        address: address,
        phone: '',
        description: ''
      });

      openSnackbar("Cadastro realizado com sucesso", "success");

      // after success, reset all data
      setUserSuccess(false);
      setUser({email: '', password: '', name: ''});
      setProvider({
        account_id: '',
        cnpj: '',
        address: '',
        phone: '',
        description: ''
      });

    }, error => {
      console.log("create_provider error", error);
    })
  };

  return (
    <FormBox>
      {!userSuccess && (
        <Box mt={4} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <Typography color="primary" variant="h5">
            Cadastrar usuário
          </Typography>
          { usersList && usersList.length > 0 && (
            <Box display="flex" flexDirection="column" justifyContent="center" mt={2} sx={{width: '200px'}}>
              <FormControl fullWidth>
                <InputLabel id="user-select-label">Selecione o usuário</InputLabel>
                <Select
                  labelId="user-select-label"
                  id="user-select"
                  value={selectedUser}
                  label="Selecione o usuário"
                  onChange={(event) => setSelectedUser(event.target.value)}
                >
                  {usersList.map((user) => (
                    <MenuItem key={user.email} value={user}>
                      {user.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box mt={4}>
                <Button variant="contained" type="button" disabled={!selectedUser} onClick={confirmSelectedUser}>Confirmar</Button>
              </Box>

              <Divider sx={{ marginTop: '15px'}}/>
            </Box>
          )}
          <Box display="flex" flexDirection="row" justifyContent="center" >
            <form onSubmit={handleSubmitUser} style={{width: '200px'}}>
              <Box mt={2}>
                <TextField autoComplete="off" name="name" label="Nome" variant="outlined" type="name" value={user.name} onChange={handleUserInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="email"  label="Email" variant="outlined" type="email" value={user.email} onChange={handleUserInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="password"  label="Senha" variant="outlined" type="password" value={user.password} onChange={handleUserInputChange} fullWidth/>
              </Box>
              <Box mt={4}>
                <Button variant="contained" type="submit">Cadastrar</Button>
              </Box>
            </form>
          </Box>
        </Box>
      )}
      {userSuccess && (
        <Box mt={4} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <Typography color="primary" variant="h5">
            Cadastrar fornecedor
          </Typography>
          <Box display="flex" flexDirection="row" justifyContent="center" >
            <form onSubmit={handleSubmitProvider}>
              <Box mt={2}>
                <TextField autoComplete="off" name="name" label="Nome" variant="outlined" type="name" value={provider.name} onChange={handleProviderInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="cnpj" label="CNPJ" variant="outlined" type="text" value={provider.cnpj}  onChange={handleProviderInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="phone" label="Telefone" variant="outlined" type="text" value={provider.phone}  onChange={handleProviderInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="description" label="Descrição" variant="outlined" type="text" value={provider.description}  onChange={handleProviderInputChange} fullWidth/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="cep" label="Cep" variant="outlined" type="text" value={cep} onChange={handleBuscaApiCall} inputProps={{maxLength: 10}} fullWidth sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '14px',
                  },
                }}/>
              </Box>
              <Box mt={2} display="flex" textAlign="left" sx={{width: '100%', alignItems: 'space-between'}}>
                <Box sx={{ flex: '1', marginRight: '16px' }}>
                    <TextField autoComplete="off" name="localidade" label="Cidade" variant="outlined" type="text" value={address.localidade} disabled InputProps={{readOnly: true}} sx={{
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                    },
                    }}/>
                </Box>
                <Box sx={{ flex: '1' }}>
                    <TextField autoComplete="off" name="uf" label="Estado" variant="outlined" type="text" value={address.uf} disabled InputProps={{readOnly: true}} fullWidth sx={{
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                    },
                    }}/>
                </Box>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="logradouro" label="Rua" variant="outlined" type="text" value={address.logradouro} disabled InputProps={{readOnly: true}} fullWidth sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '14px',
                  },
                }}/>
              </Box>
              <Box mt={2}>
                <TextField autoComplete="off" name="bairro" label="Bairro" variant="outlined" type="text" value={address.bairro} disabled InputProps={{readOnly: true}} fullWidth sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '14px',
                  },
                }}/>
              </Box>
              <Box mt={2} display="flex" textAlign="left" sx={{width: '100%'}}>
                <Box sx={{marginRight: '16px', flex: '1'}}>
                    <TextField autoComplete="off" name="numero" label="Número" onChange={handleAddressChange} variant="outlined" type="text" value={address.numero} fullWidth sx={{
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                    },
                    }}/>
                </Box>
                <Box sx={{flex: '1'}}>
                    <TextField autoComplete="off" name="complemento" label="Complemento" onChange={handleAddressChange} variant="outlined" type="text" value={address.complemento} sx={{
                    '& .MuiInputBase-input': {
                        fontSize: '14px',
                    },
                    }}/>
                </Box>
              </Box>
              <Box mt={4}>
                <Button variant="contained" type="submit">Cadastrar</Button>
              </Box>
              </form>
            </Box>
          </Box>
      )}
    </FormBox>
  );
};

export default NewProvider
